/**
 * Chống double-submit: khoá theo key trong lúc request async đang chạy.
 * Dùng: this.withSubmitLock('save', async () => { await ApiService.put(...) })
 * Hiển thị: :is-busy="isSubmitting('save')" (SaveButton) hoặc :disabled="isSubmitting('save')".
 */
export default {
  data() {
    return { submitLocks: {} };
  },
  methods: {
    isSubmitting(key = 'default') {
      return !!this.submitLocks[key];
    },
    async withSubmitLock(key, fn) {
      if (typeof key === 'function') {
        fn = key;
        key = 'default';
      }
      if (this.submitLocks[key]) return;
      this.$set(this.submitLocks, key, true);
      try {
        return await fn();
      } finally {
        this.$set(this.submitLocks, key, false);
      }
    },
  },
};
